<template>
  <business-trip-request-employee-form v-model="employee" @input="change" :exclude="employees" refreshable
                                       @close="close" @save="save" @refresh="refresh" v-if="loaded" />
</template>

<script>
import Promise from 'promise-polyfill'
import Vuex from 'vuex'
import _ from 'lodash'

import BusinessTripRequestEmployeeForm from './BusinessTripRequestEmployeeForm'

const btRequestStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Request')
const btRequestEmployeesStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Employees')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

export default {
  name: 'business-trip-request-employee-new',
  components: {
    BusinessTripRequestEmployeeForm
  },
  props: {
    backRoute: {
      type: [String, Object],
      required: true
    }
  },
  data () {
    return {
      employee: {},
      request: {},
      employees: [],
      loaded: false,
      modified: false
    }
  },
  methods: {
    ...btRequestEmployeesStore.mapActions({
      getNewEmployee: 'getNewEmployee',
      addEmployee: 'addEmployee',
      getEmployees: 'getEmployees'
    }),
    ...btRequestStore.mapActions({
      getRequest: 'getRequest'
    }),
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    loadResources () {
      const self = this
      const resources = [self.getNewEmployee({vueinstance: self}),
        self.getRequest({vueinstance: self, id: self.$route.params.id}),
        self.getEmployees({vueinstance: self, id: self.$route.params.id})]

      Promise.all(resources)
        .then(res => {
          self.employee = _.cloneDeep(res[0])
          self.request = _.cloneDeep(res[1].content)
          self.employee.fromCity = _.cloneDeep(self.request.fromCity)
          self.employee.toCity = _.cloneDeep(self.request.toCity)
          self.employees = _.cloneDeep(res[2]).map(x => x.employee.empId)
          self.loaded = true
        })
        .catch(err => self.$error(err))
    },
    close () {
      const self = this
      if (self.modified) {
        const yesHandler = () => {
          self.$router.replace(this.backRoute)
          self.closeConfirmation()
        }

        const noHandler = () => {
          self.closeConfirmation()
        }

        this.showConfirmation({
          message: 'Are you sure?',
          title: 'Closing. Business Trip Request Employee ' + this.request.batchNo + ' will not saved',
          buttons: [{label: 'Yes', handler: yesHandler}, {label: 'No', handler: noHandler}]
        })
      } else {
        self.$router.replace(this.backRoute)
      }
    },
    save (employee) {
      const self = this

      self.loaded = false
      self.employee = employee
      self.employee.sppd = self.request
      self.loaded = true

      self.addEmployee({vueinstance: self,
        id: self.$route.params.id,
        orgid: self.request.hcOrganization.id,
        emp: self.employee})
        .then(res => {
          self.loaded = false
          self.employee = _.cloneDeep(res)
          self.loaded = true

          self.$success('Business Trip Request Employee ' + self.employee.employee.name + ' added')
          self.$router.replace(this.backRoute)
          self.modified = false
        })
        .catch(err => self.$error(err))
    },
    change () {
      this.modified = true
    },
    refresh (employee) {
      const self = this

      self.loaded = false
      self.getNewEmployee({vueinstance: self})
        .then(res => {
          self.employee = _.cloneDeep(res)
          self.loaded = true
        })
        .catch(err => self.$error(err))
    }
  },
  mounted () {
    this.loadResources()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.loadResources())
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/business-trip/BusinessTripRequestEmployeeNew.vue